export const ERROR_MESSAGES = {
  USER_NOT_FOUND: "User not found.",
  NOT_AUTHENTICATED: "User is not authenticated.",
  NOT_ENOUGH_CREDITS: "Not enough credits to analyze job.",
  FAILED_CREATE_ANALYSIS: "Failed to create job analysis.",
  FAILED_DELETE_ANALYSIS: "Failed to delete job analysis.",
  FAILED_TO_START_CV_GENERATION: "Failed to start CV generation.",
  INVALID_JOB_ID: "Job ID not found.",
  INVALID_JOB_URL: "Job URL not valid.",
  INVALID_ANALYSIS_ID: "Invalid analysis ID.",
  UPGRADE_NEEDED: "You need to upgrade to access this feature.",
  UNEXPECTED: "An unexpected error occurred.",
  LINKEDIN_DATA_COULD_NOT_BE_CRAWLED: "LinkedIn profile data could not be crawled.",
  LINKEDIN_PROFILE_URL_NOT_FOUND: "LinkedIn profile URL not found. Please update in settings.",
  JOB_ANALYSIS_NOT_FOUND: "Job analysis not found.",
  NO_PERMISSIONS: "You do not have permission to perform this action.",
  ANALYSIS_NOT_FOUND: "Analysis not found.",
  CV_NOT_FOUND: "CV not found.",
  CV_COULD_NOT_BE_PARSED: "CV could not be parsed.",
  INVALID_CV_ID: "Invalid CV ID.",
  CV_FILE_NOT_EXISTING: "CV file does not exist.",
  SOMETHING_WENT_WRONG: "Something went wrong. Please try again later.",
  JOB_ANALYSIS_DID_NOT_FAIL: 'Job analysis did not fail.',
};

export const SUCCESS_MESSAGES = {
  JOB_ANALYSIS_STARTED: "Job analysis started successfully.",
  PROFILE_UPDATED_SUCCESSFULLY: "Profile updated successfully.",
  ACCOUNT_DELETED_SUCCESSFULLY: "Account deleted successfully.",
  PROFILE_ANALYSIS_SUCCESSFUL: "Profile analysis successful.",
  RECRUITER_LENS_ANALYSIS_SUCCESSFUL: "Recruiter's lens analysis successful.",
  APPLICATION_STATUS_UPDATED: "Application status updated successfully.",
  JOB_ANALYSIS_DELETED: "Job analysis deleted successfully.",
  CUSTOMIZED_CV_STARTED: "Customized CV generation started successfully.",
  CUSTOMIZED_CV_GENERATED: "Customized CV generated successfully.",
  CV_UPLOADED_SUCCESSFULLY: "CV uploaded successfully.",
  CUSTOMIZED_CV_DELETED: "Customized CV deleted successfully.",
  ANALYSIS_REDEEMED: "Analysis redeemed successfully.",
}